<template>
  <div class="handle-content">
    <div class="desc" v-if="!isRegisterMode">
      Pick a handle from your connected Instagram or TikTok to personalize your storefront URL. 
      <el-link :underline="false" @click="openConnct()">Connect account.</el-link>
    </div>

    <MessageBox :msg="'You can only change your username once every 7 days.'" />

    <div class="selcet-box" v-loading="loading">
      <!-- will change url-->
      <div class="prepend">{{ storefrontUrlPrefix }}</div>
      <el-select :model-value="getHandleValue"  placeholder="---Select---" :disabled="!store.user?.can_update_user_handle || loading"
        popper-class="custom-select-picker">
        <template #label>
          <span>{{ getHandleValue?.handle || '---Select---' }}</span>
        </template>

        <el-option v-for="(item, index) in socialHandleList" :key="index" class="items-center" :value="`${item.handle}-fake`"
          :class="{ 'is-selected': getHandleValue?.handle === item.handle }"
          @click="handleSelect(item)">
          <svg-icon :name="item.icon" />
          <span>{{ item.handle }}</span>
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useGlobalStore } from '@/stores/GlobalStore';
import { useRegisterStore } from '@/stores/RegisterStore';
import MessageBox from '@shared/components/ui/MessageBox.vue';
import emitter from '@shared/utils/EventBus';
const store = useGlobalStore();
const registerStore = useRegisterStore();
const emit = defineEmits(['updateHandle']);
const props= defineProps({
  handleValue: {
    type: String,
    default: ''
  },

});

const isRegisterMode = window.location.href.includes('register');
const getHandleValue = ref(null);
const socialHandleList = ref([]);
const loading = ref(false);
const storefrontUrlPrefix = process.env.VUE_APP_Prod === 'true'
  ? 'cjcreator.com/shop/'
  : 'cj-qa.shop.anchor.store/storefronts/'
//++++++++++++++++++++++
const openConnct = () => {
  emitter.emit('open-connect-dialog');
};
//handle get icon
const handleSelect = (item) => {
  getHandleValue.value = item;
  emit('updateHandle', item.handle);
};
//+++++++++++++++++++++++
const buildHandleList = (sourceList) => {
  socialHandleList.value = [];
  const isRegister = window.location.href.includes('register');
  sourceList.forEach(e => {
    const lookupKey = isRegister ? e.social_platform : e.from;
    const social = store.initSocial.find(i => i.backName.includes(lookupKey));
    // register mode: only show handles with a known social platform icon
    // non-register mode: show all handles
    if (isRegister) {
      if (social?.icon) {
        socialHandleList.value.push({ ...e, icon: social.icon });
      }
    } else {
      // exclude youtube handles in non-register mode since we currently don't support them, to avoid confusion. We can remove this exclusion once youtube handles are supported.
      // Jira ticket 11570 #5
      const youtubeBackNames = ['youTube', 'youtube', 'youtube_business'];
      if (!youtubeBackNames.includes(lookupKey)) {
        socialHandleList.value.push({ ...e, icon: social?.icon ?? 'people' });
      }
    }
  });
  socialHandleList.value.forEach(e => {
    if (e.handle === props.handleValue) {
      getHandleValue.value = e;
    }
  });

  console.log('socialHandleList', socialHandleList.value);
  if (getHandleValue.value === null) {
    handleSelect(socialHandleList.value[0]);
  }
};

onMounted(async () => {
  if (window.location.href.includes('register')) {
    // Register mode: use RegisterStore.spHandle
    if (registerStore.spHandle.length) {
      buildHandleList(registerStore.spHandle);
      return;
    }
    // spHandle is empty — show loading until API resolves
    loading.value = true;
    // Wait 2s for spHandle to be populated by the register flow
    await new Promise(resolve => setTimeout(resolve, 2000));
    if (!registerStore.spHandle.length) {
      // Still empty: re-call the API once
      await registerStore.spGetUserHandle();
    }
    buildHandleList(registerStore.spHandle);
    loading.value = false;
  } else {
    // Non-register mode: use store.user.user_handle_list
    if (store.user?.user_handle_list?.length) {
      buildHandleList(store.user.user_handle_list);
      return;
    }
    // 等兩秒讓 store 自行填充
    await new Promise(resolve => setTimeout(resolve, 2000));
    if (!store.user?.user_handle_list?.length) {
      await store.getUserMe();
    }
    buildHandleList(store.user.user_handle_list ?? []);
  }
});
</script>

<style lang="scss">
.handle-content{
  display: grid;
  gap:8px;
  width: 100%;
}
</style>
